import React, { useState } from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

const bnrimg = require('./../../images/banner/2.jpg');

const BlogGrid = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phone: '',
    bankInfo: null,
    registrationDoc: null,
    gosi: null,
    vat: null,
    products: null,
    chamber: null,
    zakat: null,
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  const data = new FormData();
  
  // Append all fields
  Object.keys(formData).forEach(key => {
    if (formData[key] !== null) {
      data.append(key, formData[key]);
    }
  });

  try {
    const response = await fetch("https://alaussback-production.up.railway.app/api/suppliers/register", {
      method: "POST",
      body: data,
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || 
        `Server responded with ${response.status}: ${response.statusText}`
      );
    }

    const result = await response.json();
    alert("تم الإرسال بنجاح!");
    console.log("Success:", result);
    
  } catch (error) {
    console.error("Error details:", error);
    alert(`حدث خطأ أثناء الإرسال: ${error.message}`);
  }
};
  const inputTextStyle = {
    fontFamily: 'Cairo, sans-serif',
    fontSize: '15px',
    fontWeight: '700'
  };
  const pagestyle = {
    direction: 'rtl',
    textAlign: 'right',
    fontFamily: 'Cairo, sans-serif'
  };

  return (
    <>
      <Header />
      <div className="page-content">
        <Banner
          title="بوابة الموردين تمكن الموردين الجدد من تقديم طلبات التسجيل كموردين معتمدين"
          pagename="بوابة الموردين"
          bgimage={bnrimg}
        />
        <div className="section-full p-tb80 bg-white inner-page-padding" style={pagestyle}>
          <div className="container">
            <div className="section-content">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">

                  {/* File Uploads */}
                  <div className="col-md-6">
                    <h4 style={inputTextStyle}>المرفقات</h4>
                    {[
                      { name: 'bankInfo', label: 'معلومات البنك' },
                      { name: 'registrationDoc', label: 'السجل التجاري / الرخصة التجارية' },
                      { name: 'gosi', label: 'شهادة التأمينات الاجتماعية GOSI' },
                      { name: 'vat', label: 'شهادة ضريبة القيمة المضافة' },
                      { name: 'products', label: 'المنتجات والخدمات' },
                    ].map((field) => (
                      <div className="form-group" key={field.name}>
                        <label style={inputTextStyle}>{field.label} (PDF)</label>
                        <input
                          type="file"
                          name={field.name}
                          className="form-control"
                          accept=".pdf"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                    ))}
                    <div className="text-left m-t20">
                      <button type="submit" className="site-button btn-effect">
                        إرسال
                      </button>
                    </div>
                  </div>

                  {/* Text Inputs */}
                  <div className="col-md-6">
                    <h4 style={inputTextStyle}>البيانات الشخصية</h4>
                    <div className="form-group">
                      <input
                        name="username"
                        type="text"
                        required
                        className="form-control"
                        placeholder="الاسم"
                        value={formData.username}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        name="email"
                        type="email"
                        required
                        className="form-control"
                        placeholder="البريد الإلكتروني"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        name="phone"
                        type="text"
                        required
                        className="form-control"
                        placeholder="رقم الهاتف"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                    </div>

                    <h4 style={{ ...inputTextStyle, marginTop: '20px' }}>الوثائق التجارية</h4>
                    {[
                      { name: 'chamber', label: 'الغرفة التجارية' },
                      { name: 'zakat', label: 'شهادة الزكاة' },
                    ].map((field) => (
                      <div className="form-group" key={field.name}>
                        <label style={inputTextStyle}>{field.label} (PDF)</label>
                        <input
                          type="file"
                          name={field.name}
                          className="form-control"
                          accept=".pdf"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogGrid;